export default "__VITE_ASSET__BFxqh4Ln__"